import React, { useState } from 'react';
import '../../App.css';
import './Screenshots.css';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Footer from '../Footer';
import { useTranslation } from "react-i18next";
import s1 from '../../assets/images/s1.png'
import s2 from '../../assets/images/s2.png'
import s3 from '../../assets/images/s3.png'
import s4 from '../../assets/images/s4.png'
import s5 from '../../assets/images/s5.png'
import s6 from '../../assets/images/s6.png'
import s7 from '../../assets/images/s7.png'


export default function About() {

  const images = [s1, s2, s3, s4, s5, s6, s7];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };



  const { t } = useTranslation();

  return <div className="about-container">
    <div className="screenshot-form">

      <Slider {...settings}>
        {images.map((image, index) => (
          <div key={index}>
            <img src={image} alt={`Image ${index + 1}`} className='screenshot-class' />
          </div>
        ))}
      </Slider>



    </div>
    <Footer />
  </div>
}
